import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-saude-resumo-modal-datas',
  imports: [CommonModule],
  templateUrl: './saude-resumo-modal-datas.html',
  styleUrl: './saude-resumo-modal-datas.scss',
})
export class SaudeResumoModalDatas implements OnChanges {
  @Input() open = false;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() mode: 'single' | 'multi' = 'single';
  @Input() options: Array<{ id: string | number; label: string; badge?: string }> = [];
  @Input() selectedId?: string | number;
  @Input() selectedIds: Array<string | number> = [];

  @Output() confirm = new EventEmitter<any>();
  @Output() close = new EventEmitter<void>();

  _selectedId?: string | number;
  _selectedIds: Array<string | number> = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedId']) {
      this._selectedId = this.selectedId;
    }
    if (changes['selectedIds']) {
      this._selectedIds = [...this.selectedIds];
    }
  }

  isSelected(id: string | number): boolean {
    return this.mode === 'single'
      ? this._selectedId === id
      : this._selectedIds.includes(id);
  }

  toggle(id: string | number) {
    if (this.mode === 'single') {
      this._selectedId = id;
      this.confirm_();
    } else {
      const idx = this._selectedIds.indexOf(id);
      idx === -1
        ? this._selectedIds.push(id)
        : this._selectedIds.splice(idx, 1);
    }
  }

  confirm_() {
    const result = this.mode === 'single'
      ? { mode: 'single', selectedId: this._selectedId }
      : { mode: 'multi', selectedIds: [...this._selectedIds] };

    this.confirm.emit(result);
  }

  onOverlayClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('modal-overlay')) {
      this.close.emit();
    }
  }
}